import { API_BASEURL, API_URL, SPJWT } from "@/configs";
import { getCookie } from "@/utils/session";

import { getServiceUrlHost, getServiceUrlOrigin } from "./servicePaths";

// auth header todo after using token
const authHeader = async (withToken?: boolean, serverSideReq?: any, serviceBaseUrl?: string) => {
  const resolvedBaseUrl = serviceBaseUrl || API_URL;
  const header: Record<string, string> = {};

  // Browsers own Host and Origin. Supplying them from fetch() is forbidden and
  // can turn an otherwise valid same-origin request into a network failure.
  if (typeof window === "undefined") {
    header.Host = getServiceUrlHost(resolvedBaseUrl) || API_BASEURL || "";
    header.Origin = getServiceUrlOrigin(resolvedBaseUrl) || "";
  }

  if (withToken) {
    const token = getCookie(SPJWT, serverSideReq);
    if (token) {
      header.Authorization = "Bearer " + token;
    }
  }
  return header;
};

export const getHeaders = (res: Response) => {
  const headers = {};
  for (const [key, value] of res.headers) {
    headers[key] = value;
  }
  return headers;
};

export const cookiesToHeaders = (cookies: string[]): string => {
  const text = cookies
    .map((cookie) => {
      return `${cookie}=${getCookie(cookie)}`;
    })
    .join("; ");
  return text;
};

export default authHeader;
